import React from 'react'

import Section from './Section'

export default function SectionSkeleton({
  icon,
  transparentOnDesktop
}: {
  icon?: React.ReactNode
  transparentOnDesktop?: boolean
}) {
  return (
    <Section compact icon={icon} transparentOnDesktop={transparentOnDesktop} noPill>
      <div className="flex items-center animate-pulse">
        <div className="flex-1">
          <div className="h-6 w-3/5 bg-gray-200 dark:bg-zinc-600 rounded"></div>
        </div>
        <div className="py-1 pl-1 w-8 sm:w-20">
          <div className="h-7 w-full bg-gray-200 dark:bg-zinc-600 rounded"></div>
        </div>
      </div>
    </Section>
  )
}
